import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

const AdminRoute = ({ children }) => {
    const { isAuthenticated, isAdmin } = useAuth()
    const location = useLocation()

    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />
    }

    if (!isAdmin) {
        // Non-admin users trying to access admin routes get redirected to dashboard
        return <Navigate to="/dashboard" replace />
    }

    return children
}

export default AdminRoute
